module.exports = __webpack_public_path__ + "media/img/payments/credit-card-8c5ac3a544ab5cdef9d7bb7a09f45fb9.svg";